<template>
    <div class="delete-wrestler-form should-dim modify-form">
        <div>
            Are you sure you want to move this wrestler to alum status?<br/>
            This will remove most of their access to WrestlingIQ, including removing them from rosters and messaging groups.
        </div>
        <div class="">
            <small v-show="error"><span class="text-danger">{{ errorMessage }}</span></small>
            <br/>
            <button v-on:click="hideDeleteForm" class="btn btn-default">Cancel</button>
            <ladda-button @lbClicked="deleteWrestlerPressed" el-class="btn-danger" :loading="loading">
                Yes, move to alum
            </ladda-button>
        </div>
    </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';

export default {
  name: 'delete-wrestler-form',
  components: { LaddaButton },
  props: [
    'wrestlerId',
  ],
  data() {
    return {
      loading: false, // Loading is a network variable (hitting the api)

      error: false,
      errorMessage: 'Error, please try again later or contact support.',
    };
  },
  methods: {
    hideDeleteForm() {
      const vm = this;
      vm.$notificationManager.emit('hide-delete-wrestler-form', vm.wrestlerId);
    },
    deleteWrestlerPressed: _.throttle(function () {
      const vm = this;
      // If this is a duplicate request, just return
      if (vm.loading === true) {
        return;
      }
      vm.loading = true;

      const url = vm.$apiService.wrestlerUrl(vm.wrestlerId);
      axios.delete(url)
        .then((response) => {
          vm.loading = false;

          vm.$notificationManager.emit('show-toast', 'Wrestler is now an alum', true);
          vm.$notificationManager.emit('wrestler-deleted', vm.wrestlerId);
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = 'Error, please try again later or contact support.';
          vm.error = true;
        });
    }, 500),
  },
};
</script>
